import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const Packages = React.lazy(() => import('./index'));
const PackageTable = React.lazy(() => import('./packageTable'));
const Package = React.lazy(() => import('./package'));
const PackageDetail = React.lazy(() => import('./packageDetail'));
const AddNewPackage = React.lazy(() => import('./addNewPackage'));
const EditPackage = React.lazy(() => import('./editPackage'));

export const usePackageRoutes = () => {

    return (
        <Route path="packages" element={<Suspense fallback={<div>منتظر باشید...</div>}><Packages /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><PackageTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewPackage/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><Package/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><PackageDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditPackage/></Suspense> } />
            </Route>
        </Route>
    )
}